<template>
  <div>
    <div class="container-fluid mt--6x">
      <div class="card">
        <div class="card-header border-0">
          <div class="row">
            <div class="col-sm-12 col-md-4">
              <h3 class="mb-2">Recetas del día</h3>
            </div>
            <div class="col-sm-12 col-md-4">
              <base-input addon-left-icon="ni ni-calendar-grid-58" class>
                <flat-picker
                  slot-scope="{focus, blur}"
                  @on-open="focus"
                  @on-close="blur"
                  :config="{allowInput: true}"
                  class="form-control datepicker"
                  v-model="date"
                  placeholder="Seleccione fecha"
                ></flat-picker>
              </base-input>
            </div>
            <div class="col-sm-12 col-md-4 text-right">
              <button
                type="button"
                class="btn btn-primary active btn-sm"
                @click="showPhotosMenus"
                role="button"
                aria-pressed="true"
              >Ver fotos de carta</button>
              <button
                  type="button"
                  class="btn btn-dark active btn-sm"
                  @click="downloadReport"
                  role="button"
                  aria-pressed="true"
              >Descargar preguntas</button>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 text-center">
              <span class="badge badge-lg badge-warning">RECUERDA QUE TIENES HASTA EL VIERNES A LAS 4 PM PARA PODER REALIZAR LA APROBACIÓN DE TODAS LAS RECETAS DE LA SEMANA.
                <br/> <br/> CUALQUIER CONSULTA, ESCRIBE A NUESTRA LÍNEA DE ATENCIÓN.<br><br></span>
            </div>
          </div>
        </div>
        <div class="row starter-page">
          <div class="container-fluid">
            <el-table
              class="table-responsive table-flush"
              header-row-class-name="thead-light"
              row-key="id"
              :data="meals"
              @selection-change="onSelectionChange"
            >
              <el-table-column label="Alimento" min-width="220px" prop="meal_id" sortable>
                <template v-slot="{row}">
                  <div class="table-user">
                    <img :src="'https://app.manzanaverde.la/'+row.image_url" alt />
                    {{ row ? row.name.toUpperCase() : ''}}
                    <span class="badge badge-lg badge-danger" v-if="row.meal_status && row.meal_status === 2">Receta observada</span>
                    <span class="badge badge-lg badge-info" v-else-if="!row.meal_status">Pendiente</span>
                    <span class="badge badge-lg badge-success" v-else-if="row.meal_status && row.meal_status === 3">Resuelto</span>
                    <span class="badge badge-lg badge-success" v-else-if="row.meal_status && row.meal_status === 1">Aprobado</span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                label="Opciones"
                prop="subgroup_id"
                width="350px"
                min-width="300px"
                sortable
              >
                <template v-slot="{row}">
                  <div class="one-row">
                    <a :href="'/#/receta/'+row.id">
                      <base-button type="success" class="btn-sm">Ver</base-button>
                    </a>
                    <br />&nbsp;
                    <template v-if="!disabledGeneral">
                      <a href="javascript:void(0);"  class="px-2" v-if="row.meal_status && row.meal_status === 1">
                        <base-button type="default" class="btn-sm">
                          Receta aprobada
                        </base-button>
                      </a>
                      <a href="javascript:void(0);" v-else @click="approvedRecipe(row)" class="px-2">
                        <base-button :disabled="row.meal_status && [2,3].includes(row.meal_status)" type="warning" class="btn-sm">
                          Aprobar receta
                        </base-button>
                      </a>
                    </template>
                    <template v-else>
                      <a href="javascript:void(0);"  class="px-2">
                        <base-button disabled type="warning" class="btn-sm">
                          Aprobar receta
                        </base-button>
                      </a>
                    </template>
                    <template v-if="!disabledGeneral">
                      <a href="javascript:void(0);" v-if="!row.meal_status"  class="ask"  @click="nextWppSuccess()">
                        <base-button type="primary" class="btn-sm">Preguntar</base-button>
                      </a>
                      <a href="javascript:void(0);" v-else-if="row.meal_status && row.meal_status === 1">
                        <base-button disabled type="primary" class="btn-sm">Preguntar</base-button>
                      </a>
                      <a href="javascript:void(0);" v-else class="ask"  @click="nextWppSuccess()">
                        <base-button type="primary" class="btn-sm">Preguntar</base-button>
                        <span class="badge-mod" v-if="row.answer">
                          <i class="ni ni-notification-70" style="color: red"></i>
                        </span>
                      </a>
                    </template>
                    <template v-else>
                      <a href="javascript:void(0);">
                        <base-button disabled type="primary" class="btn-sm">Preguntar</base-button>
                      </a>
                    </template>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <br />
          </div>
        </div>
      </div>
    </div>

    <CustomModal :is-modal="show_to_ask"
                 @closeModal="show_to_ask = false"
                 :closeOuth="true"
    >
      <div class="row">
        <div class="col-sm-12">
          <h3 class="text-center">Consultas</h3>
        </div>
        <div class="col-sm-12">
          <textarea class="form-control" v-model="message" placeholder="Ingrese preguntas u observaciones que tenga acerca de la receta…." cols="30" rows="5">
          </textarea>
        </div>
        <div class="col-sm-12">
         <div class="text-center mt-2">
           <button
               type="button"
               :disabled="disabledButton"
               class="btn btn-success btn-sm"
               @click="sendAsk"
           >Enviar
           </button>
         </div>
        </div>
      </div>
    </CustomModal>

    <CustomModal :is-modal="show_to_answer"
                 @closeModal="show_to_answer = false"
                 :closeOuth="true"
    >
      <div class="row">
        <div class="col-sm-12">
          <h3 class="text-center">Consultas</h3>
        </div>
        <div class="chat">
          <div class="chat__wrapper">
            <div v-for="message in messages" :key="message.id">
              <div class="chat__message" v-if="message.catering_id === message.responsable_id">
                <div class="date"></div>
                <div>{{ message.message}}</div>
              </div>
              <div v-else class="chat__message chat__message-own">
                <div class="date"></div>
                <div>{{ message.message}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12 text-center" v-if="!responseComplete && messages.length === 2 ">
          <h3>¿Estas conforme con la respuesta?</h3>
          <button type="button" :disabled="disabledButton" @click="sendAgree('SI')" class="btn btn-success btn-sm">SI</button>
          <button type="button" :disabled="disabledButton" @click="sendAgree('NO')" class="btn btn-warning btn-sm">NO</button>
        </div>
        <div class="col-sm-12 text-center" v-else-if="responseComplete">
          <h3>Tu consulta ya fue resuelta</h3>
        </div>
        <div v-else class="col-sm-12 text-center">
          <h3>Esperando una respuesta...</h3>
        </div>
      </div>
    </CustomModal>

    <CustomModal :is-modal="show_photos"
                 @closeModal="show_photos = false"
                 :closeOuth="true"
    >
      <div class v-if="photos.length">
        <img
          :src="photo.full_url"
          style="width: 100%;margin-bottom: 10px"
          :key="photo.id"
          alt
          v-for="photo in photos"
        />
      </div>
      <div class v-else>
        <h3>No existen fotos de la carta semanal</h3>
      </div>
      <template slot="footer">
        <button type="button" class="btn btn-link ml-auto" @click="show_photos = false">CERRAR</button>
      </template>
    </CustomModal>


  </div>
</template>
<script>
import axios from "axios";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import StatsCard from "@/components/Cards/StatsCard";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {Dropdown, DropdownItem, DropdownMenu, Table, TableColumn, Tooltip,} from "element-ui";
import Modal from "@/components/Modal";
import backofficeApi from "@/gateways/backoffice-api";
import moment from "moment";
import CustomModal from "../../components/CustomModal";
import swal from "sweetalert2";

export default {
  name: "starter-page",
  components: {
    Modal,
    StatsCard,
    RouteBreadCrumb,
    flatPicker,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    CustomModal,
  },
  data() {
    return {
      show_photos: false,
      show_to_ask: false,
      show_to_answer: false,
      meal: {},
      user: [],
      selectedRows: [],
      date: moment().format('YYYY-MM-DD'),
      meals: [],
      photos: [],
      message: '',
      messages: [],
      responseComplete: false,
      disabledButton: false,
      disabledGeneral: true
    };
  },
  computed: {
    checkMessage() {
      return this.message.length > 0
    },
  },
  created() {
    this.checkDisabledButton(this.date)
    this.get_meals_by_day();
  },
  watch: {
    date(value) {
      this.checkDisabledButton(value)
      this.get_meals_by_day();
    },
  },
  methods: {
    checkDisabledButton(value) {
      let currentDayNumber = moment().day(); //numeroDiaActual
      let currentHour = moment().hour() //hora actual
      let rangeNextWeek = this.getDaysNextWeek() //rangoPróximaSemana
      let existsBetween = this.between(value,rangeNextWeek[0],rangeNextWeek[1])
      this.disabledGeneral = !(currentDayNumber <= 5 && existsBetween && currentHour < 16);
    },
    onSelectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    get_meals_by_day() {
      axios
        .get("/recipes/get_recipe_by_day", { params: { date: this.date } })
        .then((response) => {
          this.meals = response.data;
        })
        .catch((error) => console.log(error));
    },
    async showPhotosMenus() {
      try {
        const userData = JSON.parse(localStorage.getItem('userData'))
        const response = await backofficeApi.get(`${process.env.VUE_APP_API_BACKOFFICE_URL}weekly/menus/photo`,{
          params: {
            date: this.date,
            catering_id: userData.catering_id
          }
        }
        )
        this.show_photos = true;
        this.photos = response.data.data.images;
        console.log(response);
      } catch (e) {
        console.log(e);
      }
    },
    async approvedRecipe(item){
       try{
         const response = await axios.post('/recipe-approved',{
          meal_id : item.id,
          date: this.date,
          status: 2
         })
         this.get_meals_by_day()
         await swal({
           title: response.data.message,
           buttonsStyling: false,
           type: response.data.status,
           confirmButtonClass: 'btn btn-success btn-fill'
         });


       }catch (e) {
         console.log(e)
       }
    },
    toAsk(item){
      this.show_to_ask = true
      this.message = ''
      this.meal = item
    },
    async toAnswer(item){
      this.show_to_answer = true
      this.meal = item
      const response = await axios.get('/evaluation/messages', {
        params: {
          meal_id: item.id,
          date: this.date
        }
      })
      this.messages = response.data.messages
      this.responseComplete = response.data.response_complete
    },
    async sendAsk() {
       if(this.message.length === 0) return;
      try{
        this.disabledButton = true
        await axios.post('/evaluation/message', {
          meal_id: this.meal.id,
          date: this.date,
          message: this.message,
        })
        this.show_to_ask = false
        this.disabledButton = false
        this.get_meals_by_day()
      }catch (e) {
        console.log(e)
      }
    },
    async sendAgree(decision) {
       let message = `${decision} estoy de acuerdo`
      try{
        this.disabledButton = true
        await axios.post('/evaluation/message/agree', {
          meal_id: this.meal.id,
          date: this.date,
          message: message,
          response: decision
        })
        this.show_to_answer = false
        this.disabledButton = false
        this.get_meals_by_day()
      }catch (e) {
        console.log(e)
      }
    },
    downloadReport(){
      axios({
        url: "/evaluation/report",
        responseType: "blob",
        method: "get",
        params: {
          date: this.date,
        },
      }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
                "download",
                "evaluacion-recetas-" + moment(new Date()).format("YYYY-MM-DD") + ".pdf"
            );
            document.body.appendChild(link);
            link.click();
          })
          .catch((error) => console.log(error));
    },
    getDaysNextWeek() {
       return [
          moment().add(1, 'weeks').startOf('week').format("YYYY-MM-DD"),
         moment().add(1, 'weeks').endOf('week').format("YYYY-MM-DD")
       ]
    },
    between(x, min, max) {
      return x >= min && x <= max;
    },
    nextWppSuccess() {
        window.open(
            `https://api.whatsapp.com/send?phone=+12063604300&text=¡Hola!%20Tengo%20una%20consulta%20sobre%20una%20receta`,
            '_blank'
        )

    }
  },
};
</script>
<style>
.starter-page {
  min-height: calc(100vh - 380px);
}
.one-row {
  display: flex;
  align-items: center;
}
.weekly_menus {
  max-width: 800px;
}
.ask .badge-mod {
  position: absolute;
  top: -10px;
  right: -10px;
  padding: 5px 10px;
  border-radius: 50%;
  background: #fdd1da;
  font-size: 10px;
}
.ask {
  /*background-color: #555;*/
  /*color: white;*/
  /*text-decoration: none;*/
  /*padding: 15px 26px;*/
  position: relative;
  display: inline-block;
  /*border-radius: 2px;*/
}
.chat {
  width: 100%;
  max-width: 800px;
  /*height: calc(100vh - 50px);*/
  min-height: 100%;
  padding: 15px 30px;
  margin: 0 auto;
  overflow-y: scroll;
  background-color: #fff;
  transform: rotate(180deg);
  direction: rtl;
}
.chat__wrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column-reverse;
  flex-direction: column-reverse;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
}
.chat__message {
  font-size: 18px;
  padding: 10px 20px;
  border-radius: 25px;
  color: #000;
  background-color: #e6e7ec;
  max-width: 600px;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  position: relative;
  margin: 15px 0;
  word-break: break-all;
  transform: rotate(180deg);
  direction: ltr;
}
.chat__message:after {
  content: "";
  width: 20px;
  height: 12px;
  display: block;
  background-image: url("/img/icon-gray-message.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  position: absolute;
  bottom: -2px;
  left: -5px;
}
.chat__message-own {
  color: #fff;
  margin-left: auto;
  background-color: #00a9de;
}
.chat__message-own:after {
  width: 19px;
  height: 13px;
  left: inherit;
  right: -5px;
  background-image: url("/img/icon-blue-message.png");
}
.chat__form {
  background-color: #e0e0e0;
}
.chat__form form {
  max-width: 800px;
  margin: 0 auto;
  height: 50px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.chat__form input {
  height: 40px;
  font-size: 16px;
  min-width: 90%;
  padding-left: 15px;
  background-color: #fff;
  border-radius: 15px;
  border: none;
}
.chat__form button {
  width: 10%;
  height: 100%;
  font-size: 16px;
  background-color: transparent;
  border: none;
  text-align: center;
  text-transform: uppercase;
  cursor: pointer;
}
.chat__form button:hover {
  font-weight: bold;
}

</style>
